var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9602 21.9668H2.99002C2.43984 21.9668 1.99336 21.5203 1.99336 20.9702V3.02992C1.99336 2.47975 2.43989 2.03326 2.99002 2.03326H11.9602C12.5113 2.03326 12.9568 1.58776 12.9568 1.03661C12.9568 0.48545 12.5113 0.039856 11.9602 0.039856H2.99002C1.34152 0.039856 0 1.38142 0 3.02992V20.9701C0 22.6186 1.34152 23.9601 2.99002 23.9601H11.9602C12.5113 23.9601 12.9568 23.5146 12.9568 22.9635C12.9568 22.4123 12.5113 21.9668 11.9602 21.9668Z",
    fill: "#444851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7031 11.2904L17.6433 5.31028C17.2526 4.92356 16.6207 4.92858 16.234 5.32027C15.8472 5.71196 15.8512 6.34285 16.2439 6.72956L20.5745 11.0033H8.97017C8.41901 11.0033 7.97351 11.4488 7.97351 12C7.97351 12.5511 8.41901 12.9967 8.97017 12.9967H20.5745L16.2439 17.2704C15.8513 17.6571 15.8483 18.288 16.234 18.6797C16.4293 18.877 16.6864 18.9767 16.9436 18.9767C17.1968 18.9767 17.4499 18.881 17.6433 18.6896L23.7031 12.7095C23.8924 12.5222 24.0001 12.267 24.0001 11.9999C24.0001 11.7329 23.8934 11.4788 23.7031 11.2904Z",
    fill: "#444851"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e58355acd0f2cbdef5363ffd45a72774.svg";
export { ForwardRef as ReactComponent };